import React, { useEffect, useState } from 'react'
import LeadTypeConversionForm from '../../components/Forms/LeadTypeConversion/LeadTypeConversionForm'
import HeaderTabLayout from '../../components/HeaderTabLayout'
import Layout from '../../components/Layout'
import { useLeadTypeConversion } from '../../hooks/CompanyConfiguration/useLeadTypeConversion'
import { ROUTES } from '../../shared/constants'

export default function AddLeadTypeConversion({ leadTypeConversion }) {
  const { addLeadTypeConversion, updateLeadTypeConversion, loading } = useLeadTypeConversion()
  const [leadTypeConversionForm, setLeadTypeConversionForm] = useState({
    convertFrom: '',
    convertTo: '',
    conversionDuration: '',
  })

  const handleAddLeadTypeConversion = () => {
    if (leadTypeConversion) {
      updateLeadTypeConversion({
        convertLeadTypeId: leadTypeConversion._id,
        convertFrom: leadTypeConversionForm.convertFrom,
        convertTo: leadTypeConversionForm.convertTo,
        convertDuration: leadTypeConversionForm.conversionDuration,
      })
    } else {
      addLeadTypeConversion({
        convertFrom: leadTypeConversionForm.convertFrom,
        convertTo: leadTypeConversionForm.convertTo,
        convertDuration: leadTypeConversionForm.conversionDuration,
      })
    }
  }

  useEffect(() => {
    if (leadTypeConversion) {
      setLeadTypeConversionForm({
        ...leadTypeConversionForm,
        convertFrom: leadTypeConversion.convertFrom._id,
        convertTo: leadTypeConversion.convertTo._id,
        conversionDuration: leadTypeConversion.convertDuration,
      })
    }
  }, [leadTypeConversion])

  return (
    <Layout heading="Lead Type Conversion" heading2={leadTypeConversion ? 'Edit' : 'Add'} url1={ROUTES.LEADTYPE_CONVERSION} none>
      <HeaderTabLayout
        heading={`${leadTypeConversion ? 'Edit' : 'Add'} Lead Type Conversion`}
        content={<LeadTypeConversionForm form={leadTypeConversionForm} setForm={setLeadTypeConversionForm} />}
        addContent={handleAddLeadTypeConversion}
        redirect={ROUTES.LEADTYPE_CONVERSION}
        loading={loading}
        state={leadTypeConversionForm}
        setState={setLeadTypeConversionForm}
      />
    </Layout>
  )
}
